import * as msal from "@azure/msal-browser";
import * as microsoftTeams from '@microsoft/teams-js';

let msalInstance = null;
let msalInitialized = false;

const reactClientId= process.env.REACT_APP_CLIENT_ID;
const reactFunctionEndpoint = process.env.REACT_APP_FUNCTION_ENDPOINT;
const reactTenantId = process.env.REACT_APP_TENANT_ID;
const reactAuthHost = process.env.REACT_APP_OAUTH_AUTH_HOST;

/* export const initializeMsal= () => {
  if(!msalInstance){
    msalInstance = new msal.PublicClientApplication({
      auth: {
        clientId:clientID_Env, // Replace with your Azure AD app client ID
        authority: "https://login.microsoftonline.com/"& tenantID, // Replace with your Azure AD tenant ID",
        redirectUri: redirectUri_Env, // or your Teams tab redirect URL
        //redirectUri: redirectUri_Env, // or your Teams tab redirect URL
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
    });
    msalInstance.initialize();
    msalInitialized=true;
    console.log('msal initialized successfully');
  }
}; */

export const initializeMsal= () => {
  if(!msalInstance){
    msalInstance = new msal.PublicClientApplication({
      auth: {
        clientId: reactClientId, // Replace with your Azure AD app client ID
        authority: `${reactAuthHost}/${reactTenantId}/v2.0`, // Replace with your Azure AD tenant ID",
        redirectUri: `${reactFunctionEndpoint}/auth-end.html?clientId=${reactClientId}`,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
    });
    msalInstance.initialize();
    msalInitialized=true;
  }
};

export const initializeTeams=()=>{
  if(window.microsoftTeams){
    window.microsoftTeams.app.initialize();
  } else {
    msalInstance.initialize();
  }
};

export const ensureMsalInitialized=()=>{
  if(!msalInitialized){
    console.error('msal not initialized.')
    initializeMsal();
  }
};

/* export const signIn = async(setPopupBlocked) => {
  try{
    ensureMsalInitialized();
    
    const loginResponse = await msalInstance.ssoSilent({scopes: ['User.Read','Directory.Read.All'],});
    if(loginResponse && loginResponse.account){
      console.log("user signed in", loginResponse.account);
      return loginResponse.accessToken;
    }

  } catch (error){
      console.error("Silent SignIn failed, proceeding with interactive login: "& error);

      try{
        const loginResponse = await msalInstance.loginPopup({scopes: ['User.Read','Directory.Read.All'],});
        if(loginResponse && loginResponse.account){
          console.log("user signed in", loginResponse.account);
          return loginResponse.accessToken;
        }

      } catch (popupError) {
        console.error("Interative login failed: ", popupError);

        if(popupError.message && popupError.message.toLowerCase().includes("popup")){
          alert ("Please enable popups in your browser settings to view announcements.");
          setPopupBlocked(true);
          return null;
        }
      } 
  }
  return null;
};  */

export const signIn = async(setPopupBlocked) => {
  try{
    ensureMsalInitialized();
    
    
    const loginResponse = await msalInstance.ssoSilent({scopes: ['User.Read','Directory.Read.All'],});
    if(loginResponse && loginResponse.account){
      //console.log("user signed in", loginResponse.account);
      return loginResponse.accessToken;
    }

  } catch (error){
      console.error("Silent SignIn failed, proceeding with interactive login: "& error);

      try{
        const loginResponse = await msalInstance.loginPopup({scopes: ['User.Read','Directory.Read.All'],});
        if(loginResponse && loginResponse.account){
          //console.log("user signed in", loginResponse.account);
          return loginResponse.accessToken;
        }

      } catch (popupError) {
        console.error("Interative login failed: ", popupError);

        if(popupError.message && popupError.message.toLowerCase().includes("popup")){
          alert ("Please enable popups in your browser settings to view announcements.");
          setPopupBlocked(true);
          return null;
        }
      } 
  }
  return null;
}; 

export const acquireToken = async()=> {
  try{
    ensureMsalInitialized();
    const account = msalInstance.getActiveAccount();
    const tokenResponse=await msalInstance.acquireTokenSilent({scopes: ['User.Read','Directory.Read.All'],});
    return tokenResponse.accessToken;
  } catch (error){
      console.error('token acq error', error);
      const tokenResponse=await msalInstance.acquireTokenPopup({scopes: ['User.Read','Directory.Read.All'],});
    return tokenResponse.accessToken;
  }
};
  
export const fetchUserProfile = async () => {
  try{
    const token = await signIn();
    const response = await fetch("https://graph.microsoft.com/v1.0/me", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if(!response.ok){
    }
    const data = await response.json();
    //console.log("User Profile data: ", data);
    return data;
  }catch (error){
    console.error("Error fetching user profile", error);
  }
};

const handleDesktopAuth=()=>{
  microsoftTeams.authentication.getAuthToken({
    successCallback: (token) => {
      //console.log("Desktop token retrieved: ", token);
      msalInstance.setActiveAccount(token);
      exchangeTokenForGraphToken(token);
    },
    failureCallback:(error)=>{
      console.error("Failed to get desktop auth token: ", error);
    },
  });
};

const exchangeTokenForGraphToken = async(teamsToken) => {
  try{
    const response = await fetch(`${reactAuthHost}/${reactTenantId}/oauth2/v2.0/token`,{
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded"},
      body: new URLSearchParams({
        client_id: reactClientId,
        grant_type: "urn:ietf:params:oauth:grant-type:jwt-bearer",
        requested_token_use: "on_behalf_of",
        assertion: teamsToken,
        scope: "https://graph.microsoft.com/.default",
      }),
    });

    const data = await response.json();
    return data.access_token;
  } catch (error){
    console.error("Token exchange error: ", error);
  }
};


export const getGraphToken = async()=>{
  initializeMsal();
  try{
    const account = msalInstance.getActiveAccount();

    if(!account) {

    }

    const tokenResponse = await msalInstance.acquireTokenSilent({
      account: account,
      scopes: ["https://graph.microsoft.com/.default"],
    });

    if(tokenResponse && tokenResponse.accessToken) {
      //console.log("Graph api token retrieved: ", tokenResponse.accessToken);
      return tokenResponse.accessToken;
    }
  } catch (silentTokenError){
    try{
      const tokenResponse = await msalInstance.acquireTokenPopup({
        scopes:["https://graph.microsoft.com/.default"],
      });

      if(tokenResponse && tokenResponse.accessToken){
        //console.log("Graph API token retrieved via popup", tokenResponse.accessToken);
        return tokenResponse.accessToken;
      }
    } catch (popupTokenError){
      console.error("Failed to acquire token: ", popupTokenError);
    }
  }
};

export const fetchGraphData = async()=>{
  try{
    const graphToken = await getGraphToken();
    const response = await fetch ("https://graph.microsoft.com/v1.0/me",{
      method: "GET",
      headers: {
        Authorization: `Bearer ${graphToken}`,
      },
    });

    if(!response.ok){

    }

    const data = await response.json();
    //console.log("Graph Api data: ", data);
    return data;

  } catch (error){
    console.error("Error fetching graph data: ", error);
  }
};

/* export const exchangeTokenForGraphAPI = async(aadToken) =>{
  try{
    const tenantId = reactTenantId;
    const clientId = reactTenantId;
    const redirectUri = "https://localhost:53000/auth-end.html";
    const scope = "User.Read Directory.Read.All";
    const authUrl = `${reactAuthHost}/${tenantId}/oauth2/v2.0/authorize?`+
        `clientId: ${clientId}` +
        `&response_type=code`+
        `&redirect_uri = ${encodeURIComponent(redirectUri)}`+
        `scope: ${encodeURIComponent(scope)}`+
        `&response_mode=query`;
    window.location.href=authUrl; 
    
  } catch (error){
    console.error("Failed to exchange token for graph api token: ", error);
  }
};
 */

export const callGraphAPI = async(accessToken) =>{
  try{
    const response = await fetch('https://graph.microsoft.com/v1.0/me',{
      method:'GET',
      headers:{
        Authorization: `Bearer ${accessToken}`,
        'content-type': 'application/json',
      },
    });
    if(!response.ok){
      throw new Error(`http error: ${response.status}`);
    }
    const data = await response.json();
    //console.log("Graph api response: ", data);
  } catch (error) {
    console.error("Error calling graph api: ", error);
  }
};
